import { env } from "$env/dynamic/public";

/**
 * Convex deployment URL. Set `PUBLIC_CONVEX_URL` in `.env.local` (dev) or the
 * Cloudflare Pages build environment. Falls back to the local Convex backend.
 */
export const CONVEX_URL = env.PUBLIC_CONVEX_URL || "http://127.0.0.1:3210";

if (!env.PUBLIC_CONVEX_URL) {
  console.warn(
    "[env] PUBLIC_CONVEX_URL is not set; falling back to the local Convex backend.",
  );
}
